// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let IconV5 = require("../common/Components/IconV5.bs.js");
let Scalars = require("../../scalars/Scalars.bs.js");
let UTCDate = require("../../reason/common/types/UTCDate.bs.js");
let V4 = require("uuid/v4");
let DateFns = require("date-fns");
let ButtonsV5 = require("../common/Components/ButtonsV5.bs.js");
let Link = require("next/link").default;
let SectionLabel = require("../common/Components/SectionLabel.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let ConfirmDialog = require("../common/Components/ConfirmDialog.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let SystemMessages = require("../../reason/systemMessages/SystemMessages.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let MyDraftsWidgetDraftListItem_draft_graphql = require("../../__generated__/MyDraftsWidgetDraftListItem_draft_graphql.bs.js");
let MyDraftsWidgetDraftListItem_DeleteDraftV5Mutation_graphql = require("../../__generated__/MyDraftsWidgetDraftListItem_DeleteDraftV5Mutation_graphql.bs.js");
let MyDraftsWidgetDraftListItem_ListingDraftRow_draft_graphql = require("../../__generated__/MyDraftsWidgetDraftListItem_ListingDraftRow_draft_graphql.bs.js");
let MyDraftsWidgetDraftListItem_DevelopmentProjectDraftRow_draft_graphql = require("../../__generated__/MyDraftsWidgetDraftListItem_DevelopmentProjectDraftRow_draft_graphql.bs.js");
let MyDraftsWidgetDraftListItem_DeleteDevelopmentProjectDraftMutation_graphql = require("../../__generated__/MyDraftsWidgetDraftListItem_DeleteDevelopmentProjectDraftMutation_graphql.bs.js");

let convertFragment = MyDraftsWidgetDraftListItem_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyDraftsWidgetDraftListItem_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(MyDraftsWidgetDraftListItem_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MyDraftsWidgetDraftListItem_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(MyDraftsWidgetDraftListItem_draft_graphql.node, convertFragment, fRef);
}

let DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function MyDraftsWidgetDraftListItem$ConfirmDeleteDialog(props) {
  let onCancel = props.onCancel;
  let onConfirm = props.onConfirm;
  return JsxRuntime.jsx(ConfirmDialog.make, {
    title: "Delete Draft?",
    ariaLabel: "Confirm Delete Draft",
    body: JsxRuntime.jsx(JsxRuntime.Fragment, {
      children: JsxRuntime.jsx("div", {
        children: "This will delete the draft and cannot be undone.",
        className: "leading-normal"
      })
    }),
    isOpen: props.isOpen,
    onCancel: onCancel,
    cancelButton: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
      onClick: param => onCancel(),
      children: "No, Keep Draft"
    }),
    confirmButton: JsxRuntime.jsx(ButtonsV5.DangerButton.make, {
      onClick: param => onConfirm(),
      children: "Yes, Delete Draft"
    })
  });
}

let ConfirmDeleteDialog = {
  make: MyDraftsWidgetDraftListItem$ConfirmDeleteDialog
};

function MyDraftsWidgetDraftListItem$DeleteDraftButton(props) {
  let onDelete = props.onDelete;
  let match = React.useState(() => false);
  let setIsOpen = match[1];
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(MyDraftsWidgetDraftListItem$ConfirmDeleteDialog, {
        isOpen: match[0],
        onConfirm: () => {
          setIsOpen(param => false);
          onDelete();
        },
        onCancel: () => setIsOpen(param => false)
      }),
      JsxRuntime.jsxs(ButtonsV5.SecondaryButton.make, {
        onClick: param => setIsOpen(param => true),
        disabled: props.disabled,
        size: "small",
        children: [
          JsxRuntime.jsx(IconV5.make, {
            icon: "trash"
          }),
          JsxRuntime.jsx("div", {
            className: "ml-[8px]"
          }),
          "Delete"
        ]
      })
    ]
  });
}

let DeleteDraftButton = {
  make: MyDraftsWidgetDraftListItem$DeleteDraftButton
};

let convertVariables = MyDraftsWidgetDraftListItem_DeleteDraftV5Mutation_graphql.Internal.convertVariables;

let convertResponse = MyDraftsWidgetDraftListItem_DeleteDraftV5Mutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = MyDraftsWidgetDraftListItem_DeleteDraftV5Mutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, MyDraftsWidgetDraftListItem_DeleteDraftV5Mutation_graphql.node, convertResponse, convertWrapRawResponse);

let use$1 = RescriptRelay_Mutation.useMutation(convertVariables, MyDraftsWidgetDraftListItem_DeleteDraftV5Mutation_graphql.node, convertResponse, convertWrapRawResponse);

let DeleteDraftV5Mutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$1
};

let convertVariables$1 = MyDraftsWidgetDraftListItem_DeleteDevelopmentProjectDraftMutation_graphql.Internal.convertVariables;

let convertResponse$1 = MyDraftsWidgetDraftListItem_DeleteDevelopmentProjectDraftMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$1 = MyDraftsWidgetDraftListItem_DeleteDevelopmentProjectDraftMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation$1 = RescriptRelay_Mutation.commitMutation(convertVariables$1, MyDraftsWidgetDraftListItem_DeleteDevelopmentProjectDraftMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let use$2 = RescriptRelay_Mutation.useMutation(convertVariables$1, MyDraftsWidgetDraftListItem_DeleteDevelopmentProjectDraftMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let DeleteDevelopmentProjectDraftMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  commitMutation: commitMutation$1,
  use: use$2
};

function displayLocation(address, areaName) {
  if (address !== undefined) {
    if (areaName !== undefined) {
      return address + (", " + areaName);
    } else {
      return address;
    }
  } else if (areaName !== undefined) {
    return areaName;
  } else {
    return "(no address entered)";
  }
}

function MyDraftsWidgetDraftListItem$DraftRow(props) {
  let draftLink = props.draftLink;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs(Link, {
            href: draftLink,
            className: "flex flex-col gap-1",
            children: [
              JsxRuntime.jsx(SectionLabel.make, {
                children: props.label
              }),
              JsxRuntime.jsx("div", {
                children: props.text,
                className: "text-lg font-medium"
              })
            ]
          }),
          JsxRuntime.jsx("div", {
            children: DateFns.format(UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(props.updatedAt)), "MM/dd/yyyy"),
            className: "my-2 md:my-0"
          })
        ],
        className: "col-span-12 lg:col-span-6 flex flex-col md:flex-row md:justify-between md:items-center"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs(ButtonsV5.SecondaryButton.make, {
            href: draftLink,
            size: "small",
            children: [
              JsxRuntime.jsx(IconV5.make, {
                icon: "pencil",
                size: 15
              }),
              JsxRuntime.jsx("div", {
                className: "ml-[8px]"
              }),
              "Resume"
            ]
          }),
          JsxRuntime.jsx(MyDraftsWidgetDraftListItem$DeleteDraftButton, {
            onDelete: props.onDelete,
            disabled: props.isDeleting
          })
        ],
        className: "col-span-12 lg:col-span-6 text-right flex flex-row space-x-2 md:justify-end items-center"
      })
    ],
    className: "grid grid-cols-12 gap-2 py-4 border-t"
  });
}

let DraftRow = {
  make: MyDraftsWidgetDraftListItem$DraftRow
};

function useDeleteDraftMessage() {
  let match = SystemMessages.useSystemMessages();
  let addMessage = match.addMessage;
  return didDelete => {
    let messageType = didDelete ? "info" : "error";
    let text = didDelete ? "The draft was deleted." : "There was a problem deleting your draft.";
    addMessage(SystemMessages.Message.make(V4(), messageType, text, 5000, undefined, undefined));
  };
}

let convertFragment$1 = MyDraftsWidgetDraftListItem_ListingDraftRow_draft_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyDraftsWidgetDraftListItem_ListingDraftRow_draft_graphql.node, convertFragment$1, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(MyDraftsWidgetDraftListItem_ListingDraftRow_draft_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MyDraftsWidgetDraftListItem_ListingDraftRow_draft_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(MyDraftsWidgetDraftListItem_ListingDraftRow_draft_graphql.node, convertFragment$1, fRef);
}

let Fragment_draftOrigin_decode = MyDraftsWidgetDraftListItem_ListingDraftRow_draft_graphql.Utils.draftOrigin_decode;

let Fragment_draftOrigin_fromString = MyDraftsWidgetDraftListItem_ListingDraftRow_draft_graphql.Utils.draftOrigin_fromString;

let Fragment = {
  draftOrigin_decode: Fragment_draftOrigin_decode,
  draftOrigin_fromString: Fragment_draftOrigin_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$3,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function MyDraftsWidgetDraftListItem$ListingDraftRow(props) {
  let listConnectionId = props.listConnectionId;
  let draft = RescriptRelay_Fragment.useFragment(MyDraftsWidgetDraftListItem_ListingDraftRow_draft_graphql.node, convertFragment$1, props.draft);
  let match = use$1();
  let deleteDraft = match[0];
  let handleDeleteResult = useDeleteDraftMessage();
  let match$1 = draft.origin;
  let match$2 = draft.publishedProperty;
  let draftLink;
  if (match$1 !== undefined) {
    let exit = 0;
    if (match$1 === "BROADCAST_QUIET_SELLER" || match$1 === "REBROADCAST" || match$1 === "NEW") {
      switch (match$1) {
        case "NEW" :
          draftLink = "/properties/new?draftId=" + draft.databaseId;
          break;
        case "BROADCAST_QUIET_SELLER" :
        case "REBROADCAST" :
          exit = 1;
          break;
      }
    } else {
      draftLink = "#";
    }
    if (exit === 1) {
      draftLink = match$2 !== undefined ? `/properties/` + match$2.id + `/broadcast?resumingDraft=1` : "#";
    }
  } else {
    draftLink = "#";
  }
  let match$3 = draft.origin;
  let label;
  if (match$3 !== undefined && (match$3 === "BROADCAST_QUIET_SELLER" || match$3 === "REBROADCAST" || match$3 === "NEW")) {
    switch (match$3) {
      case "BROADCAST_QUIET_SELLER" :
        label = "Quiet Property Broadcast";
        break;
      case "NEW" :
        label = "New Broadcast";
        break;
      case "REBROADCAST" :
        label = "Rebroadcast";
        break;
    }
  } else {
    label = "";
  }
  let match$4 = draft.draftProperty;
  let text = match$4 !== undefined ? displayLocation(match$4.address, Stdlib_Option.map(match$4.userSelectedArea, area => area.name)) : "(no address entered)";
  return JsxRuntime.jsx(MyDraftsWidgetDraftListItem$DraftRow, {
    draftLink: draftLink,
    label: label,
    text: text,
    updatedAt: draft.updatedAt,
    onDelete: () => {
      deleteDraft({
        connections: Stdlib_Array.keepSome([listConnectionId]),
        input: {
          draftId: draft.databaseId
        }
      }, undefined, undefined, undefined, (response, param) => {
        let match = response.deleteDraftV5;
        if (match !== undefined && match.__typename === "DraftWasDeleted") {
          return handleDeleteResult(true);
        } else {
          return handleDeleteResult(false);
        }
      }, undefined, undefined);
    },
    isDeleting: match[1]
  });
}

let ListingDraftRow = {
  Fragment: Fragment,
  make: MyDraftsWidgetDraftListItem$ListingDraftRow
};

let convertFragment$2 = MyDraftsWidgetDraftListItem_DevelopmentProjectDraftRow_draft_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyDraftsWidgetDraftListItem_DevelopmentProjectDraftRow_draft_graphql.node, convertFragment$2, fRef);
}

function use$4(fRef) {
  return RescriptRelay_Fragment.useFragment(MyDraftsWidgetDraftListItem_DevelopmentProjectDraftRow_draft_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MyDraftsWidgetDraftListItem_DevelopmentProjectDraftRow_draft_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(MyDraftsWidgetDraftListItem_DevelopmentProjectDraftRow_draft_graphql.node, convertFragment$2, fRef);
}

let Fragment_draftOrigin_decode$1 = MyDraftsWidgetDraftListItem_DevelopmentProjectDraftRow_draft_graphql.Utils.draftOrigin_decode;

let Fragment_draftOrigin_fromString$1 = MyDraftsWidgetDraftListItem_DevelopmentProjectDraftRow_draft_graphql.Utils.draftOrigin_fromString;

let Fragment$1 = {
  draftOrigin_decode: Fragment_draftOrigin_decode$1,
  draftOrigin_fromString: Fragment_draftOrigin_fromString$1,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$4,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function MyDraftsWidgetDraftListItem$DevelopmentProjectDraftRow(props) {
  let listConnectionId = props.listConnectionId;
  let draft = RescriptRelay_Fragment.useFragment(MyDraftsWidgetDraftListItem_DevelopmentProjectDraftRow_draft_graphql.node, convertFragment$2, props.draft);
  let match = use$2();
  let deleteDevelopmentProjectDraft = match[0];
  let handleDeleteResult = useDeleteDraftMessage();
  let match$1 = draft.origin;
  let match$2 = draft.publishedDevelopmentProject;
  let draftLink = match$1 !== undefined ? (
      match$1 === "BROADCAST_QUIET_SELLER" || match$1 === "REBROADCAST" || match$1 === "NEW" ? (
          match$1 === "REBROADCAST" ? (
              match$2 !== undefined ? `/developments/` + match$2.id + `/broadcast?resumingDraft=1` : "/developments/new?draftId=" + draft.databaseId
            ) : "/developments/new?draftId=" + draft.databaseId
        ) : "/developments/new?draftId=" + draft.databaseId
    ) : "/developments/new?draftId=" + draft.databaseId;
  let match$3 = draft.origin;
  let label = match$3 === "REBROADCAST" ? "Development Rebroadcast" : "New Development";
  let match$4 = draft.draftDevelopmentProject;
  let name = match$4.name;
  let text = name !== undefined ? name : displayLocation(match$4.streetAddress, Stdlib_Option.map(match$4.selectedArea, area => area.name));
  return JsxRuntime.jsx(MyDraftsWidgetDraftListItem$DraftRow, {
    draftLink: draftLink,
    label: label,
    text: text,
    updatedAt: draft.updatedAt,
    onDelete: () => {
      deleteDevelopmentProjectDraft({
        connections: Stdlib_Array.keepSome([listConnectionId]),
        input: {
          draftId: draft.databaseId
        }
      }, undefined, undefined, undefined, (response, param) => {
        let match = response.deleteDevelopmentProjectDraft;
        if (match !== undefined && match.__typename === "DevelopmentProjectDraftWasDeleted") {
          return handleDeleteResult(true);
        } else {
          return handleDeleteResult(false);
        }
      }, undefined, undefined);
    },
    isDeleting: match[1]
  });
}

let DevelopmentProjectDraftRow = {
  Fragment: Fragment$1,
  make: MyDraftsWidgetDraftListItem$DevelopmentProjectDraftRow
};

function MyDraftsWidgetDraftListItem(props) {
  let listConnectionId = props.listConnectionId;
  let draft = RescriptRelay_Fragment.useFragment(MyDraftsWidgetDraftListItem_draft_graphql.node, convertFragment, props.draft);
  switch (draft.__typename) {
    case "DevelopmentProjectDraft" :
      return JsxRuntime.jsx(MyDraftsWidgetDraftListItem$DevelopmentProjectDraftRow, {
        draft: draft.fragmentRefs,
        listConnectionId: listConnectionId
      });
    case "DraftV5" :
      return JsxRuntime.jsx(MyDraftsWidgetDraftListItem$ListingDraftRow, {
        draft: draft.fragmentRefs,
        listConnectionId: listConnectionId
      });
    case "__unselected" :
      return null;
  }
}

let make = MyDraftsWidgetDraftListItem;

exports.DraftFragment = DraftFragment;
exports.ConfirmDeleteDialog = ConfirmDeleteDialog;
exports.DeleteDraftButton = DeleteDraftButton;
exports.DeleteDraftV5Mutation = DeleteDraftV5Mutation;
exports.DeleteDevelopmentProjectDraftMutation = DeleteDevelopmentProjectDraftMutation;
exports.displayLocation = displayLocation;
exports.DraftRow = DraftRow;
exports.useDeleteDraftMessage = useDeleteDraftMessage;
exports.ListingDraftRow = ListingDraftRow;
exports.DevelopmentProjectDraftRow = DevelopmentProjectDraftRow;
exports.make = make;
/* commitMutation Not a pure module */
